module.exports = __webpack_public_path__ + "static/15-a820bd1183a4fdd8e7203b82ec0441e4.jpg";